import FileSaver from 'file-saver';
import { useCallback } from 'react';

import { useAlert } from '../../context/alert/hooks';

import { PolicyAPI } from './api';

export const useDownloadPolicy = () => {
  const { addAlert } = useAlert();

  const downloadFile = useCallback(
    async (orgId: string, policyId?: string, versionId?: string) => {
      try {
        const result = await PolicyAPI.getExportData(
          orgId,
          policyId,
          versionId
        );
        if (result.success && result.data?.s3Url) {
          addAlert('success', 'File generated successfully.');
          const file = await PolicyAPI.getFile(result.data.s3Url);
          FileSaver.saveAs(
            file,
            result.data.fileName || `${crypto.randomUUID()}.zip`
          );
        }
      } catch (e: any) {
        addAlert('error', `Failed to download the file. ${e}`);
      }
    },
    []
  );

  return { downloadFile };
};
